import Splitter from "../Splitter";
import MainContainer from "../MainContainer";
import DirectionHandler from "../DirectionHandler";
import { AppRoutes } from "../../constants";
import { useAppSelector } from "../../redux";
import { selectText } from "../LanguageSelect/LanguageSelectSlice";
import { Navigate } from "react-router-dom";
import { Button, Grid, Typography } from "@mui/material";
import { selectIsCompleted, selectPaneemStatus, selectRequestId } from "../../AppSlice";
import { selectAddress, selectCurrectInfo, selectContactEmail, selectPhone, selectRegNum } from "./ContactInfoSlice";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import PhoneIcon from "@mui/icons-material/Phone";
import AlternateEmailIcon from "@mui/icons-material/AlternateEmail";
import { Card } from "./Card";
import { CustomModal } from "./CustomModal";
import { useContactInfo } from "./hooks";
import { ContactConfirmPage } from "./ContactConfirmPage";
import { PaneemConfirmPage } from "./PaneemConfirmPage";

export default function _CompletionPage() {
  const isCompleted = useAppSelector(selectIsCompleted);
  const regNum = useAppSelector(selectRegNum);
  const status = useAppSelector(selectPaneemStatus);
  const text = useAppSelector(selectText);
  const msg = text.confirm_info;
  const originalInfo = useAppSelector(selectCurrectInfo);
  const address = useAppSelector(selectAddress);
  const phone = useAppSelector(selectPhone);
  const email = useAppSelector(selectContactEmail);
  const requestId = useAppSelector(selectRequestId);

  const { edit, type, modal, setmodal, confirmContactInfo, errMsg } = useContactInfo();

  if (!isCompleted) return <Navigate to={AppRoutes.home} replace />;

  return (
    <Grid container component="main" justifyContent="flex-end">
      <Splitter />
      <CustomModal
        type={type}
        modal={modal}
        handleClose={() => {
          setmodal(false);
        }}
      />

      <DirectionHandler>
        <MainContainer title="" titleVariant="h4">
          {regNum && status === "approved" && !requestId ? (
            originalInfo && address ? (
              <Grid
                container
                direction="row"
                justifyContent="center"
                alignItems="center"
                alignContent={"center"}
                spacing={2}
              >
                {msg.map((string, i) => {
                  return (
                    <Grid key={i} item xs={12} xl={12}>
                      <Typography variant="h3" textAlign={"center"}>
                        {string}
                      </Typography>
                    </Grid>
                  );
                })}
                <Card
                  info={`${address.street} ${address.building} ${address.city} ${address.state} ${address.country} ${address.zipcode}`}
                  msg={text.validation_er.missing_address}
                  type="address"
                  edit={edit}
                  icon={<LocationOnIcon fontSize="medium" sx={{ marginRight: 2, color: "#8C827A" }} />}
                />
                <Card
                  info={phone}
                  msg={text.validation_er.missing_phone}
                  type="phone"
                  edit={edit}
                  icon={<PhoneIcon fontSize="medium" sx={{ marginRight: 2, color: "#8C827A" }} />}
                />
                <Card
                  info={email}
                  msg={text.validation_er.missing_email}
                  type="email"
                  edit={edit}
                  icon={<AlternateEmailIcon fontSize="medium" sx={{ marginRight: 2, color: "#8C827A" }} />}
                />

                <Grid item xs={12} xl={12}>
                  <Button
                    variant="contained"
                    sx={{ width: "100%", margin: 0 }}
                    onClick={confirmContactInfo}
                    type="button"
                    color="primary"
                    id="confirm_button"
                  >
                    {text.confirm}
                  </Button>
                  <Typography color="red" variant="h6">
                    {errMsg}
                  </Typography>{" "}
                </Grid>
              </Grid>
            ) : (
              <ContactConfirmPage />
            )
          ) : (
            <PaneemConfirmPage />
          )}
        </MainContainer>
      </DirectionHandler>
    </Grid>
  );
}
